import { vars } from "@imwebme/clay-token";
import type { Ref } from "react";
import { forwardRef } from "react";
import { Flex } from "../../utilities";
import { contentAnimation, modalSizeMap } from "../Modal.css";
import type { VisualModalContainerProps } from "./VisualModal.types";

export const VisualModalContainer = forwardRef(
  ({ width, children }: VisualModalContainerProps, ref: Ref<HTMLDivElement>) => {
    return (
      <Flex.Column
        ref={ref}
        backgroundColor={vars.semantic.color.surface}
        native={{ role: "dialog", onClick: (e) => e.stopPropagation() }}
        borderRadius={vars.rounded.xlarge}
        overflow="hidden"
        width={modalSizeMap[width]}
        boxShadow={vars.dropShadow.modal}
        animation={`${contentAnimation} 0.2s ease-out`}
        gap={vars.spacing[6]}
      >
        {children}
      </Flex.Column>
    );
  },
);
